import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from 'packages/app/Layout';
import DefaultGrid from 'packages/app/DefaultGrid';
import Table from 'packages/shared/Table';
import { GROUP, SUBGROUPS, ORGANIZATION, LOCATION } from './graphql';
import { useQuery } from '@apollo/react-hooks';
import Summary from 'packages/shared/Summary';
import { useParams, useNavigate } from 'react-router-dom';
import ParticipantTable from 'components/ParticipantTable';
import { format } from 'date-fns';
import { Loader } from 'packages/shared/core';
import { useFilter } from 'hooks';

const SubgroupOverview = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const history = useNavigate();
    const [participants, setParticipants] = useState([]);
    const [groupRows, setGroupRows] = useState([]);
    const tableHead = [t('GENERAL.GROUP'), t('GENERAL.PARTICIPANTS')];
    const [mailOpen, setMailOpen] = useState(false);

    const { data: organisationData = {} } = useQuery(ORGANIZATION, {
        variables: {
            page: 1,
            id: params.id,
            ascending: false
        }
    });
    const organization = organisationData.getOrganisationById;

    const { data: locationData = {} } = useQuery(LOCATION, {
        variables: {
            page: 1,
            id: params.locationId,
            ascending: false
        }
    });
    const location = locationData.getLocationById;

    // queries
    const { data = {} } = useQuery(SUBGROUPS, {
        variables: {
            page: 1,
            groupId: params.groupId
        }
    });
    const subGroups = data.getPaginatedSubgroupsByGroupId;

    const filter = useFilter({
        pagination: { sortProperties: ['state'], direction: false }
    });

    const { data: group = {}, loading } = useQuery(GROUP, {
        variables: {
            page: filter.query.pagination.page,
            id: params.groupId,
            ascending: filter.query.pagination.direction
        }
    });
    const groupItem = group.getGroupById;

    useEffect(() => {
        if (groupItem && groupItem.formParticipants) {
            const _rows = groupItem.formParticipants.items.map((participant) => {
                return [
                    {
                        label: participant.firstName + ' ' + participant.lastName || 'Leeg',
                        id: participant.id,
                        firstName: participant.firstName,
                        lastName: participant.lastName,
                        birthdate: format(new Date(participant.birthdate), 'MM-dd-yyyy') || 'Leeg',
                        email: participant.email
                    },
                    {
                        label: participant.results.length
                    },
                    {
                        label: participant.results.length
                            ? format(
                                  new Date(
                                      participant.results[participant.results.length - 1].date
                                  ),
                                  'dd-MM-yyyy'
                              )
                            : 'Geen'
                    }
                ];
            });

            setParticipants(_rows);
        }
    }, [groupItem]);

    useEffect(() => {
        if (subGroups) {
            const _rows = subGroups.items.map((group) => {
                return [
                    {
                        label: group.name || 'Leeg',
                        id: group.id
                    },
                    {
                        label: group.amountFormParticipants
                    }
                ];
            });

            setGroupRows(_rows);
        }
    }, [subGroups]);

    const handleRowClick = (data) => {
        history.push(
            `/organisation/${params.id}/location/${params.locationId}/group/${params.groupId}/subgroup/${data[0].id}`
        );
    };

    const handleMailClick = () => {
        setMailOpen(true);
    };

    const handleMailClose = () => {
        setMailOpen(false);
    };

    if (loading && !participants.length) return <Loader centered />;
    return (
        <Layout>
            <DefaultGrid
                title={organization && organization.name}
                location={location && location.name}
                group={groupItem && groupItem.name}
                onMailClick={handleMailClick}
            >
                {groupItem && groupItem.averageEnergizersPerResult.length ? (
                    <Summary
                        title={groupItem && groupItem.name}
                        rows={groupItem ? groupItem.averageEnergizersPerResult : []}
                    />
                ) : (
                    ''
                )}
                {groupRows && groupRows.length ? (
                    <Table
                        layout="fixed"
                        head={tableHead}
                        rows={groupRows}
                        onClick={handleRowClick}
                    />
                ) : (
                    ''
                )}
                {groupRows && !groupRows.length && (
                    <ParticipantTable
                        filter={filter}
                        onClose={handleMailClose}
                        mailOpen={mailOpen}
                        participants={participants}
                    />
                )}
            </DefaultGrid>
        </Layout>
    );
};

export default SubgroupOverview;
